import React from "react";
import PropTypes from "prop-types";

const Tag = ({ backgroundColor, text, textColor, style }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center px-2 py-1"
      style={{
        borderRadius: "20px",
        backgroundColor: backgroundColor,
        fontWeight: "500",
        width: "fit-content",
        ...style,
      }}
    >
      <span style={{ color: textColor, fontSize: "11px" }}>{text}</span>
    </div>
  );
};

Tag.propTypes = {
  backgroundColor: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
};

export default Tag;
